module.exports = __webpack_public_path__ + "images/emoji/cinema.b02d5abfb14bf6c596cb.png";